import {
  testPasswordComplexity,
  UserPasswordComplexityType,
} from "../../hooks/usePasswordComplexity";
import i18n from "../../translations/i18n";

const passwordMessage = () => {
  return i18n.t("message_password_does_not_meet_minimum_requirements");
};

export const passwordRule = (
  value: any,
  repeatPassword: string | undefined = undefined
) => {
  let validateResult = validatePassword(
    value,
    repeatPassword !== undefined ? repeatPassword : value
  );
  return !value === true
    ? true // validate
    : value.length > 0 &&
      validateResult.hasValidLength &&
      validateResult.hasNumber &&
      validateResult.hasUpperCase &&
      validateResult.hasLowerCase &&
      validateResult.hasSpecialCharacter
    ? true
    : passwordMessage();
};

export const validatePassword = (
  password: string,
  repeatPassword: string
): UserPasswordComplexityType => {
  return testPasswordComplexity({
    password: password,
    repeatPassword: repeatPassword,
    checkMatch: true,
  });
};

export const emailRegExp =
  /^([ \t]+)?[“"”'A-Z0-9._%+-\\\(\)\[\]:;@ ]+"?@[A-Z0-9.-]+(\.[A-Z]{2,}){1,}([ \t]+)?$/i;
